import React, { useEffect, useContext, useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';
import logo from '../../img/logo.png';
import { accessLocalStorage, sendRebootSystem } from '../../services';
import './styles.css';

const Header = () => {
  const getItensStateGlobal = useContext(PbxContext);
  const { path, setPath, toggleIsChangeFormElements, toggleIsChangeFormElementsActive } = getItensStateGlobal;
  const [showButtonReturn, setShowButtonReturn] = useState('is-hidden');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [protocolUriActive, setProtocolUriActive] = useState('');
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);

  const history = useHistory();
  const currentPath = path || history.location.pathname;

  useEffect(() => {
    const user = accessLocalStorage.getUserLocalStorage();
    if (user) {
      setIsAuthenticated(true);
      setUserRole(user.user.role);
      setProtocolUriActive(user.ipRequest.replace(/http/i, 'https'));
      
      if (user.user.role === 'root') {
        toggleIsChangeFormElements('config-items', 'navbar-dropdown has-background-white-bis');
        toggleIsChangeFormElements('troubleshooting-items', 'navbar-dropdown has-background-white-bis');
      }
    }
  }, [toggleIsChangeFormElements]);

  const verifyComponentView = useCallback(() => {
    const user = accessLocalStorage.getUserLocalStorage();
    if (user) {
      const { user: { role, email, idtenant } } = user;
      if (role === 'root') {
        toggleIsChangeFormElements('config-items', 'navbar-dropdown has-background-white-bis');
        toggleIsChangeFormElements('troubleshooting-items', 'navbar-dropdown has-background-white-bis');
      }
      if (email === 'tecnico@vigossolucoes.com.br' && idtenant !== 'vgs') {
        setShowButtonReturn('is-active');
      }
    }
  }, [toggleIsChangeFormElements]);

  const sendReboot = async () => {
    history.push('/home');
    await sendRebootSystem();
  };
  
  const changeUserVigosSolucoes = async () => {
    const user = accessLocalStorage.getUserLocalStorage();
    if (user) {
      accessLocalStorage.removeUserItem();
      user.user.idtenant = 'vgs';
      accessLocalStorage.setUserLocalStorage(user);
      window.location.reload();
    }
  };

  useEffect(() => {
    verifyComponentView();
  }, [verifyComponentView]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll('.nav-dropdown-wrapper');
      let clickedInside = false;
      
      dropdowns.forEach(dropdown => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });

      if (!clickedInside) {
        setActiveDropdown(null);
        setActiveSubDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(prev => prev === dropdownName ? null : dropdownName);
    setActiveSubDropdown(null);
  };

  const toggleSubDropdown = (subDropdownName, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setActiveSubDropdown(prev => prev === subDropdownName ? null : subDropdownName);
  };

  const handleLinkClick = (callback) => {
    setActiveDropdown(null);
    setActiveSubDropdown(null);
    if (callback) callback();
  };

  if (!isAuthenticated) {
    return null;
  }

  return path !== '/' ? (
    <div className="header-vigos navbar header-custon card-header has-text-centered" role="navigation" aria-label="main navigation">
      <div className="navbar-brand mr-6">
        <p className="navbar-item logo-wrapper">
          <img src={logo} alt="logo" width="150" height="100" className="header-logo" />
        </p>
      </div>
      <div className="navbar-menu">
        <div className="navbar-start">
          <Link to="/home" className="navbar-item has-text-weight-medium nav-link-custom" onClick={() => setPath('/home')}>
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Home
          </Link>
        <div className={`navbar-item nav-dropdown-wrapper ${activeDropdown === 'callcenter' ? 'is-active' : ''}`}>
          <p 
            className="navbar-link has-text-weight-medium nav-link-custom"
            onClick={() => toggleDropdown('callcenter')}
          >
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Call Center
          </p>
          <div className={`navbar-dropdown has-background-white-bis ${activeDropdown === 'callcenter' ? 'is-active' : 'is-hidden'}`}>
            <Link to="/callcenter" className="dropdown-item" onClick={() => handleLinkClick(() => setPath('/callcenter'))}>
              <span className="dropdown-item-badge">V1</span>
              Call Center Classico
            </Link>
            <hr className="dropdown-divider"/>
            <Link to="/callcenterV2" className="dropdown-item" onClick={() => handleLinkClick(() => setPath('/callcenterV2'))}>
              <span className="dropdown-item-badge dropdown-item-badge-new">V2</span>
              Call Center Novo
            </Link>
          </div>
        </div>
          <Link to="/agenda/lista" className="navbar-item has-text-weight-medium nav-link-custom" onClick={() => setPath('/callcenter')}>
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Agenda
          </Link>
          {/* <Link to={{ pathname: protocolUriActive }} target="_blank" className="navbar-item has-text-weight-medium nav-link-custom">
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
            WebPhone
          </Link> */}
          <Link to="/dashboard" className="navbar-item has-text-weight-medium nav-link-custom" onClick={() => setPath('/dashboard')}>
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            Dashboard
          </Link>
        <div className={`navbar-item nav-dropdown-wrapper ${activeDropdown === 'config' ? 'is-active' : ''}`}>
          <p 
            className="navbar-link has-text-weight-medium nav-link-custom"
            onClick={() => toggleDropdown('config')}
          >
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            Configurações
          </p>
          <div id="config-items" name="config-items" className={`has-background-white-bis navbar-dropdown ${activeDropdown === 'config' && userRole === 'root' ? 'is-active' : 'is-hidden'}`}>
            <div name="config-dropdown-tenants" className={`dropdown ${activeSubDropdown === 'config-dropdown-tenants' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-tenants', e) }>
                  Clientes
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-tenants' ? 'is-active' : ''}`} id="dropdown-menu-tenants" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/clientes/novo" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-tenants')) }>
                    Adicionar Cliente
                  </Link>
                </div>
                <div className="dropdown-content has-background-light">
                  <Link to="/config/clientes/lista" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-tenants')) }>
                    Listar Clientes
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-network" className={`dropdown ${activeSubDropdown === 'config-dropdown-network' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className=" button is-white dropdown-item" onClick={(e) => toggleSubDropdown('config-dropdown-network', e) }>
                  Redes
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-network' ? 'is-active' : ''}`} id="dropdown-menu-trunks" role="menu">
                <div className="dropdown-content">
                  <Link to="/config/rede/ip" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    Alterar IP
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/lista" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    IP/Interfaces
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/routes" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    Configurar Rotas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/ip/routes/lista" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    Status de Rotas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/rede/transportes-voz" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    Transportes (Voz)
                  </Link>
                  <Link to="/config/rede/pjsip-tuning" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-network')) }>
                    Tunings PJSIP
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-endpoints" className={`dropdown ${activeSubDropdown === 'config-dropdown-endpoints' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white"  onClick={(e) => toggleSubDropdown('config-dropdown-endpoints', e) }>
                  Ramais
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-endpoints' ? 'is-active' : ''}`} id="dropdown-menu" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/ramal/novo" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-endpoints')) }>
                    Criar Ramal
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/ramal/lista" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-endpoints')) }>
                    Consultar Ramal
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-trunks" className={`dropdown ${activeSubDropdown === 'config-dropdown-trunks' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={(e) => toggleSubDropdown('config-dropdown-trunks', e) }>
                  Troncos
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-trunks' ? 'is-active' : ''}`} id="dropdown-menu-trunks" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/tronco/novo" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-trunks')) }>
                    Criar Tronco
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/tronco/lista" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-trunks')) }>
                    Consultar Tronco
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-queues" className={`dropdown ${activeSubDropdown === 'config-dropdown-queues' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-queues', e) }>
                  Filas
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-queues' ? 'is-active' : ''}`} id="dropdown-menu-queues" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/fila/nova" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-queues')) }>
                    Criar Fila
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/lista" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-queues')) }>
                    Consultar Filas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/membros/novo" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-queues')) }>
                    Adicionar Membros a Filas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/fila/membros/lista" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-queues')) }>
                    Consultar Membros/Filas
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-dialplan" className={`dropdown ${activeSubDropdown === 'config-dropdown-dialplan' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-dialplan', e) }>
                  Chamadas
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-dialplan' ? 'is-active' : ''}`} id="dropdown-menu-dialplan" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/chamadas-entrada" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-dialplan')) }>
                    Entrada
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/chamadas/internas" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-dialplan')) }>
                    Internas
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/chamadas/saida" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-dialplan')) }>
                    Saída
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/ura" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-dialplan')) }>
                    URAs
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/message" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-dialplan')) }>
                    Mensagens
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-uploads" className={`dropdown ${activeSubDropdown === 'config-dropdown-uploads' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-uploads', e) }>
                  Uploads
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-uploads' ? 'is-active' : ''}`} id="dropdown-menu-uploads" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/uploads" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-uploads')) }>
                    Upload Áudios
                  </Link>
                </div>
                <div className="dropdown-content has-background-light">
                  <Link to="/config/uploads/lista" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-uploads')) }>
                    Listar Áudios
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-moh" className={`dropdown ${activeSubDropdown === 'config-dropdown-moh' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-moh', e) }>
                  Música de Espera
                </Link>
              </div>
              <div className={`dropdown-menu has-text-centered ${activeSubDropdown === 'config-dropdown-moh' ? 'is-active' : ''}`} id="dropdown-menu-moh" role="menu">
                <div className="dropdown-content has-background-light has-text-centered">
                  <Link to="/config/musica-de-espera/novo" className="dropdown-item has-text-centered" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-moh')) }>
                    Adicionar Música de Espera
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/musica-de-espera/lista" className="dropdown-item has-text-centered" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-moh')) }>
                    Listar Músicas de Espera
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-integrations" className={`dropdown ${activeSubDropdown === 'config-dropdown-integrations' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-integrations', e) }>
                  Integrações WhatsApp
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-integrations' ? 'is-active' : ''}`} id="dropdown-menu-integrations" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/integracoes/nova" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-integrations')) }>
                    Nova Integração
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/integracoes/lista" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-integrations')) }>
                    Listar Integrações
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-users" className={`dropdown ${activeSubDropdown === 'config-dropdown-users' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-users', e) }>
                  Usuários
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-users' ? 'is-active' : ''}`} id="dropdown-menu-users" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/usuarios/novo" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-users')) }>
                    Novo
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/usuarios/lista" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-users')) }>
                    Consultar
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-call-inactivity" className={`dropdown ${activeSubDropdown === 'config-dropdown-call-inactivity' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={ (e) => toggleSubDropdown('config-dropdown-call-inactivity', e) }>
                  Monitoramento de Inatividade
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-call-inactivity' ? 'is-active' : ''}`} id="dropdown-menu-call-inactivity" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/config/monitoramento-inatividade/configuracao" className="dropdown-item"  onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-call-inactivity')) }>
                    Configuração
                  </Link>
                  <hr className="dropdown-divider"/>
                  <Link to="/config/monitoramento-inatividade/historico" className="dropdown-item" onClick={ () => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-call-inactivity')) }>
                    Histórico de Alertas
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-security" className={`dropdown ${activeSubDropdown === 'config-dropdown-security' ? 'is-active' : ''}`}>
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item button is-white" onClick={(e) => toggleSubDropdown('config-dropdown-security', e)}>
                  Segurança
                </Link>
              </div>
              <div className={`dropdown-menu ${activeSubDropdown === 'config-dropdown-security' ? 'is-active' : ''}`} role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/seguranca/fail2ban" className="dropdown-item" onClick={() => handleLinkClick(() => toggleIsChangeFormElementsActive('config-dropdown-security'))}>
                    Fail2Ban
                  </Link>
                </div>
              </div>
            </div>
            <hr className="dropdown-divider"/>
            <div name="config-dropdown-system" className="dropdown">
              <div className="dropdown-trigger">
                <Link to="#" className="dropdown-item" onClick={() => toggleIsChangeFormElementsActive('config-dropdown-system') }>
                  Sistema
                </Link>
              </div>
              <div className="dropdown-menu" id="dropdown-menu-system" role="menu">
                <div className="dropdown-content has-background-light">
                  <Link to="/home" className="dropdown-item" onClick={() => sendReboot() }>
                    Reboot
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`navbar-item nav-dropdown-wrapper ${activeDropdown === 'troubleshooting' ? 'is-active' : ''}`} name="logs-vigoscloud">
          <p 
            className="navbar-link has-text-weight-medium nav-link-custom"
            onClick={() => toggleDropdown('troubleshooting')}
          >
            <svg className="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
            Troubleshooting
          </p>
          <div id="troubleshooting-items" name="troubleshooting-items" className={`navbar-dropdown has-background-white-bis ${activeDropdown === 'troubleshooting' && userRole === 'root' ? 'is-active' : 'is-hidden'}`} >
            <Link to="/troubleshooting/sip" className="dropdown-item" onClick={() => { toggleIsChangeFormElementsActive('dropdown-troubleshooting'); setActiveDropdown(null); }}>
              Logs de Chamadas
            </Link>
            <hr className="dropdown-divider"/>
            <Link to="/troubleshooting/comandos" className="dropdown-item" onClick={() => { toggleIsChangeFormElementsActive('dropdown-troubleshooting'); setActiveDropdown(null); }}>
              Conectividade
            </Link>
          </div>
        </div>
        </div>
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons are-small py-0">
              <button name="returnUserVigosSolucoes" className={`button is-small py-0 btn-warning-custom ${showButtonReturn}`} onClick={() => changeUserVigosSolucoes()}>
                <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                Voltar para Usuario Tecnico
              </button>
              <Link to="/" onClick={() => { accessLocalStorage.removeUserItem(); setPath('/'); }}>
                <button className="button is-small py-0 btn-logout-custom">
                  <svg className="btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Sair
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" onClick={ () => toggleIsHidden('#navMenu') }>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    )
    : null;
}

export default Header;